<template>
  <div class="home">
    <h2 class="shrink text-center hidden-md-and-up logo-small mb-2">
      <span class="primary--text">$alaryCap</span><span class="accent--text font-italic">Madness</span>
    </h2>
    <v-sheet class="pa-4 bg2">
      <div>
        <div>1st place: $240</div>
        <div>2nd place: $120</div>
        <div>3rd place: $70</div>
        <div>4th place: $30</div>
      </div>
      <p v-if="!user">Returning users can use the same email and password used previously.</p>
      <p v-if="!user">Click <router-link class="primary--text" to="/login">HERE</router-link> to login.</p>
      <p>Click <router-link class="primary--text" to="/rules">HERE</router-link> to view the rules.</p>
    </v-sheet>

  </div>
</template>

<script>

export default {
  name: 'Home',
  data() {
    return {

    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  methods: {
    
  },
  created() {

  }
}
</script>

<style>

</style>